import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const UnstyledButton = (props) => {
  const style = {
    ...styles.reset,
    ...props.style
  }

  return (
    <button
      {...props}
      style={style}
    >
      {props.children}
    </button>)
}

UnstyledButton.defaultProps = {
  style: {}
}

UnstyledButton.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object
}

export default UnstyledButton
